import { authSlice } from '@wellesley/auth/authSlice'
import { useSelector } from 'react-redux'
import 'types/wlsy'
import { useAppsNavigate } from '@wellesley/router'

const useLoginGuardAction = () => {
  const isLogged = useSelector(authSlice.selectors.selectIsAuthenticated)
  const navigate = useAppsNavigate()

  const guardedAction =
    (action: (() => void) | (() => Promise<void>) = () => {}) =>
    () => {
      if (isLogged) {
        void action()
      } else
        navigate('/signin', { props: { redirectUrl: window.location.href } })
    }

  return guardedAction
}

export { useLoginGuardAction }
